






















import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
          company: {
              thisMonth: '20(565)',
              lastMonth: '50(923)',
              earlierLinks: 20,
          },  
          me: {
            thisMonth: '25(65)',
            lastMonth: '60(92)',
            earlierLinks: 12, 
          }
        }
    }
})
